import { Link } from 'react-router-dom';
import { ArrowL } from '../components/Icons.jsx';
import { LeadFormBand } from '../components/LeadForm.jsx';
import SEO from '../components/SEO.jsx';
import useReveal from '../hooks/useReveal.js';
import { localBusinessSchema, buildItemListSchema } from '../data/schemas.js';

const SERVICES_INDEX = [
  { slug: 'web', n: '01', title: 'בניית אתרים', pain: '"האתר לא נראה כמו הרמה של העסק."', accent: 'lilac' },
  { slug: 'landing-pages', n: '02', title: 'דפי נחיתה', pain: '"קמפיין מחר.\nאין דף."', accent: 'coral' },
  { slug: 'systems', n: '03', title: 'מערכות ואינטגרציות', pain: '"כל דבר ידני.\nהעתק-הדבק."', accent: 'teal' },
  { slug: 'automations', n: '04', title: 'אוטומציות', pain: '"עושה את אותו דבר כל יום."', accent: 'yellow' },
];

export default function ServicesIndex() {
  useReveal();
  return (
    <main className="svc-index">
      <SEO
        title="שירותים"
        description="4 שירותים. מצב אחד. כל שירות פותר כאב אחר."
        path="/services"
        schema={[
          localBusinessSchema,
          buildItemListSchema(
            SERVICES_INDEX.map(s => ({ name: s.title, url: `/services/${s.slug}` })),
            'שירותי FocusMode'
          )
        ].filter(Boolean)}
      />
      <section className="svc-index-head">
        <div className="wrap">
          <div className="svc-eyebrow"><span className="svc-eyebrow-bar"></span>השירותים</div>
          <h1 className="svc-index-h1">
            4 שירותים.<br/>
            <span className="hl-block tilt-l">מצב אחד</span>.
          </h1>
          <p className="svc-index-lede pre">
            {'כל שירות פותר כאב אחר.\nאם לא ברור לאן זה משתייך, כתבו מה תקוע.\nפוקוס מוד תגיד.'}
          </p>
        </div>
      </section>

      <section className="svc-index-list">
        <div className="wrap">
          <div className="hm-svc-list">
            {SERVICES_INDEX.map(s => (
              <Link key={s.slug} className="hm-svc-row reveal" to={`/services/${s.slug}`} data-accent={s.accent}>
                <div className="hm-svc-num">
                  {s.n}
                  <span className="hm-svc-pip" aria-hidden="true"></span>
                </div>
                <div className="hm-svc-body">
                  <div className="hm-svc-pain pre">{s.pain}</div>
                  <h3 className="hm-svc-title">{s.title}</h3>
                </div>
                <div className="hm-svc-arrow" aria-hidden="true">
                  <ArrowL size={20} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <LeadFormBand
        title={<>לא בטוח <span className="hl-block tilt-r">לאן</span>?</>}
        body={'כתבו מה תקוע.\nנגיד לאיזה כיוון זה הולך\nגם אם זה לא פוקוס מוד.'}
      />
    </main>
  );
}
